import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawPickupModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Pick-up");

		this.name = "pickup";
		this.icon = svg_Pickup;
		this.svgTextIndex = 3;
	}
}

window.customElements.define("inspx-draw-pickup-module", DrawPickupModule);

const svg_Pickup = (text) => html`
<svg width="60.06236400000001" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <metadata id="metadata2959">image/svg+xml</metadata>
 <g>
  <title>Layer 1</title>
  <g id="layer1" stroke="null">
   <g id="g5026" transform="matrix(0.7014405038002515,0,0,0.8894856892223668,-1140.7267641715202,-165.45451297253922) " stroke="null">
    <rect fill="none" stroke-miterlimit="4" stroke-dashoffset="0" id="rect3973" width="20" height="30" x="1628.22442" y="187.75821" ry="6.63393" stroke="#070707"/>
    <rect fill="#808080" stroke-miterlimit="4" stroke-dashoffset="0" id="rect3973-1" width="60" height="30" x="1648.22442" y="187.75821" stroke="#070707"/>
    <rect fill="#ffff00" stroke-miterlimit="4" stroke-dashoffset="0" id="rect3993" width="40" height="10" x="1658.22442" y="197.75821" stroke="#070707"/>
    <text stroke="#000000" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null"  font-style="normal" font-weight="normal" font-size="20px" font-family="Arial" text-anchor="middle" fill="#000000" xml:space="preserve" x="1335.20561" y="472.30013" id="text4907" transform="translate(252.5797882080078,-235.90455627441406) scale(1.0645476579666138,0.9393661618232727) ">
     ${text}
    </text>
   </g>
  </g>
 </g>
</svg>`;
